export default {
  title: 'PayPal (direct)',
  description:
    'Conectați propriul cont de afaceri PayPal pentru a accepta plăți PayPal direct, la propriul tarif. Creați o aplicație REST în PayPal Developer Dashboard și inserați Client ID-ul și Secretul mai jos.',
  connected_description: 'Contul dvs. PayPal este conectat. Plățile vor fi decontate direct în acesta.',
  guide: {
    title: 'Cum să obțineți credențialele PayPal',
    step1: 'Conectați-vă la PayPal Developer Dashboard cu contul dvs. de afaceri PayPal.',
    step2: 'Deschideți „Apps & Credentials" și creați o aplicație (sau deschideți-o pe cea existentă).',
    step3: 'Copiați Client ID-ul și Secretul aplicației.',
    step4: 'Inserați-le mai jos și faceți clic pe „Conectați PayPal".',
    environment_note:
      'Folosiți credențialele Live pentru plăți reale — comutați comutatorul Sandbox/Live din partea de sus a „Apps & Credentials".',
    open_dashboard: 'Deschideți PayPal Developer Dashboard',
  },
  status: {
    connected: 'Conectat',
  },
  fields: {
    client_id: {
      label: 'Client ID',
      placeholder: 'Client ID-ul aplicației dvs. PayPal REST',
    },
    client_secret: {
      label: 'Secret',
      placeholder: 'Secretul aplicației dvs. PayPal REST',
    },
  },
  buttons: {
    connect: 'Conectați PayPal',
    disconnect: 'Deconectați',
  },
  toasts: {
    connected: 'PayPal conectat cu succes',
    connect_failed: 'Nu s-a putut conecta PayPal',
    disconnected: 'PayPal deconectat',
    disconnect_failed: 'Nu s-a putut deconecta PayPal',
  },
};
